//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      required: false,
      default: null
    },
    freebetOptions: {
      required: false,
      default: []
    },
    meta: {
      required: false,
      default: {}
    }
  },
  computed: {
    num_valid_freebets() {
      let total = _.reject(this.freebetOptions, (freebetOption) => {
        if(!_.get(freebetOption, 'conditions.min_odds'))
          return false
        return _.get(this.meta, 'lowest_odds') <= _.get(freebetOption, 'conditions.min_odds')
      })
      

      return _.size(total)
    }
  }
}
